import { Stack, Typography, Link } from '@mui/material';
import { useLocalization } from '@/data/Localization';
import {
	footerCallCenterPhoneTextSX,
	footerCallCenterTitleSX,
	footerCallCenterReceiveOffersTitleSX,
} from '@/components/content/Footer/styles/callCenter';
import { footerCopyrightTypographyBaseSX } from '@/components/content/Footer/styles/copyright';
import { footerTypographyUnfocusedSX } from '@/components/content/Footer/styles/general';
import { SubscriptionNewsLetter } from '@/components/content/Footer/parts/SubscriptionNewsLetter';
import { PhoneIcon } from '@/components/content/Footer/parts/PhoneIcon';
import { DpLogos } from '@/components/content/Footer/parts/DpLogos';
import { SocialLinks } from '@/components/content/Footer/parts/Social';
import { Linkable } from '@/components/blocks/Linkable';

export const CallCenterDesktop = () => {
	const footerNLS = useLocalization('Footer');

	return (
		<Stack>
			<Typography
				variant="body2"
				textTransform="uppercase"
				component="div"
				sx={footerCallCenterTitleSX}
			>
				{footerNLS.CallCenter.Label.t()}
			</Typography>
			<Link href="tel:6699155300">
				<Typography variant="h6" component="div" sx={footerCallCenterPhoneTextSX}>
					<PhoneIcon width="16" height="16" viewBox="0 0 12 12" />
					{footerNLS.CallCenter.PhoneNumber.t()}
				</Typography>
			</Link>
			<Linkable href="/contactenos" sx={footerTypographyUnfocusedSX}>
				{'Consulta nuestros horarios'}
			</Linkable>
			<Typography
				variant="body2"
				textTransform="uppercase"
				component="div"
				sx={footerCallCenterReceiveOffersTitleSX}
			>
				{footerNLS.CallCenter.ReceiveOffers.t()}
			</Typography>
			<SubscriptionNewsLetter
				placeholder={footerNLS.CallCenter.EmailLabel.t()}
				buttonLabel={footerNLS.CallCenter.Subscribe.t()}
			/>
			<Stack direction="column" mt={2}>
				<DpLogos />
				<Stack direction="row" alignItems="center" spacing={2}>
					<SocialLinks />
					<Typography variant="caption" sx={footerCopyrightTypographyBaseSX}>
						{footerNLS.CopyrightFull.t({ date: `${new Date().getFullYear()}` })}
					</Typography>
				</Stack>
			</Stack>
		</Stack>
	);
};
